import h from 'virtual-dom/h';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {HistoryMessage} from "../../../../types/history";
import {VChild} from "virtual-dom";
import {HistoryMessageLiveChatDisconnectBanner} from "../models/HistoryMessages";


export default class DisconnectBanner
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;


    //#region Public Interface

    constructor(settings: DefaultSettings)
    {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    doesRender(message: HistoryMessage): boolean
    {
        return message.type === this._settings.messageConstants.livechatDisconnectBanner;
    }

    getRenderer()
    {
        return (message: HistoryMessage): VChild =>
        {
            if (!this.doesRender(message)) { return []; }

            const source = (message as HistoryMessageLiveChatDisconnectBanner).extensionData?.SessionEndReason as string;

            return h('span', [this.createBanner(source)]);
        };
    }

    //#endregion



    //#region Render Methods

    createBanner(disconnectSource: string): VChild
    {
        const constants = this._settings.livechat.textConstants;
        let primaryDisconnectText, secondaryDisconnectText, additionalDisconnectText;

        switch (disconnectSource)
        {
            case this._settings.livechat.sessionEndReason.user:
                primaryDisconnectText = constants.chatBannerUserDisconnectPrimary;
                secondaryDisconnectText = constants.chatBannerUserDisconnectSecondary;
                additionalDisconnectText = constants.chatBannerUserDisconnectAdditional;
                break;

            case this._settings.livechat.sessionEndReason.agent:
                primaryDisconnectText = constants.chatBannerOperatorDisconnectPrimary;
                secondaryDisconnectText = constants.chatBannerOperatorDisconnectSecondary;
                additionalDisconnectText = constants.chatBannerOperatorDisconnectAdditional;
                break;

            case this._settings.livechat.sessionEndReason.error:
                primaryDisconnectText = constants.chatBannerSystemDisconnectPrimary;
                secondaryDisconnectText = constants.chatBannerSystemDisconnectSecondary;
                additionalDisconnectText = constants.chatBannerSystemDisconnectAdditional;
                break;

            case this._settings.livechat.sessionEndReason.notEngaged:
                primaryDisconnectText = constants.chatBannerNotEngagedDisconnectPrimary;
                secondaryDisconnectText = constants.chatBannerNotEngagedDisconnectSecondary;
                additionalDisconnectText = constants.chatBannerNotEngagedDisconnectAdditional;
                break;

            default:
                primaryDisconnectText = constants.chatBannerSystemDisconnectPrimary;
                secondaryDisconnectText = constants.chatBannerSystemDisconnectSecondary;
                additionalDisconnectText = constants.chatBannerSystemDisconnectAdditional;
                break;
        }

        const {
            chatBannerDisconnectPrimary,
            chatBannerDisconnectSecondary,
            chatBannerDisconnectAdditional,
            chatBannerDisconnectContainer,
        } = this._settings.classNames.livechat;

        const primaryBanner = h('div', { className: chatBannerDisconnectPrimary }, primaryDisconnectText);
        const secondaryBanner = h('div', { className: chatBannerDisconnectSecondary }, secondaryDisconnectText);
        const additionalBanner = h('div', { className: chatBannerDisconnectAdditional }, additionalDisconnectText);

        return h('div', { className: chatBannerDisconnectContainer }, [primaryBanner, secondaryBanner, additionalBanner]);
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/disconnect-banner.ts